import WorkIcon from "@material-ui/icons/WorkOutline";
import UniIcon from "@material-ui/icons/SchoolOutlined";
// import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";
import BookmarkAddedOutlinedIcon from "@mui/icons-material/BookmarkAddedOutlined";

//experince info

export const experienceData = [];
experienceData[0] = {
  id: "experienceData0",
  Company: "Justice International",
  Title: "Associate Product Manager",
  Location: "Mountain View, CA",
  Date: "May 2022 — Present",
  Description:
    "▪ Lead engineering using agile to develop our web application, RCore, resulting in a 15% reduction in development time ",
  Description1:
    "▪ Design UI and mockups, contributing to a 20% acceleration in feature implementation and a 35% increase in user expectation alignment ",
  Description2:
    "▪ Define opportunities for our application based on quantitative and qualitative market analysis ",
  Description3:
    "▪ Translate pilot testing user feedback to developers and prioritize product backlog based on business needs ",
  Icon: <WorkIcon />,
};

experienceData[1] = {
  id: "experienceData1",
  Company: "Justice International",
  Title: "Software Developer",
  Location: "Mountain View, CA",
  Date: "Jun. 2021 — May 2022",
  Description:
    "▪ Collaborated with front-end and back-end developers from GitHub and Stanford to develop an application that aids Venezuelan refugees ",
  Description1:
    "▪ Developed the front-end of the web app using Vue.js, collected user input information and exchanged the data with the back-end",
  Icon: <WorkIcon />,
};

experienceData[2] = {
  id: "experienceData2",
  Company: "Code Ninjas",
  Title: "Head Instructor",
  Location: "Fremont, CA",
  Date: "Aug. 2021 — Aug. 2022",
  Description:
    "▪ Led a team of 10+ instructors through daily operations achieving a 10% increase in customer retention and 23% rise in new sign-ups",
  Description1:
    "▪ Prioritized and planned weekly strategies for the instructors to ensure the delivery of a complete and high quality customer experience",
  Description2:
    "▪ Managed technical program and operations based on student progress reports, instructors performance score and account retention rate",
  Description3:
    "▪ Taught and introduced children ages 6 - 14 to code using JavaScript, Python, HTML, CSS and Scratch",
  Icon: <WorkIcon />,
};

experienceData[3] = {
  id: "experienceData3",
  Company: "Wyse Limited",
  Title: "Wholesale Account Executive",
  Location: "London, UK",
  Date: "Nov. 2019 — Oct. 2020",
  Description:
    "▪ Oversaw orders and logistics from start to finish for over 20 accounts which resulted in 17% sales growth for wholesale",
  Description1:
    "▪ Responsible for tracking KPIs to identify gaps or inconsistencies in order to optimize processes and workflows for efficiency",
  Description2:
    "▪ Worked closely with cross-functional teams to improve the e-commerce customer experience which drove sales growth by 70%",
  Icon: <WorkIcon />,
};

experienceData[4] = {
  id: "experienceData4",
  Company: "Coach",
  Title: "Product Development and Production Coordinator",
  Location: "New York City, NY",
  Date: "Nov. 2017 — Jul. 2019",
  Description:
    "▪ Responsible for the product development process from initial design concept to commercialization for Soft Accessories and Knitwear",
  Description1:
    "▪ Managed a daily WIP chart to track the development and production status for all styles and samples",
  Description2:
    "▪ Responsible for bill of materials (BOM’s) input, yarn purchase orders, seasonal invoices, and the review of garment tests and care labels",
  Description3:
    "▪ Created seasonal cost sheets and provided cost options for merchants to help meet margin requirements, as well as hold design integrity",
  Description4:
    "▪ Built strong relationships with domestic and overseas service providers through daily communication and problem-solving in order to maintain quality control and on-time delivery for an average of 40 styles a season within two separate product timelines",
  Icon: <WorkIcon />,
};

experienceData[5] = {
  id: "experienceData5",
  Company: "La Perla",
  Title: "Wholesale Assistant",
  Location: "New York City, NY",
  Date: "Mar. 2017 — Nov. 2017",
  Description:
    "▪ Primary wholesale liaison between Account Executives and Logistics while effectively managing multiple priorities in a fast-paced and deadline-driven environment",
  Description1:
    "▪ Worked with Italian and domestic cross-functional teams to ensure timely and proactive flow-through of samples, market orders and linesheets",
  Description2:
    "▪ Prepared product information (cost, suggested retail price, colors, style information, etc.) and confirmed all market orders with buyers and Account Executives",
  Icon: <WorkIcon />,
};

//education info

export const educationData = [];

educationData[0] = {
  id: "educationData1",
  School: "Hackbright Academy - Sponsored by Walmart",
  Degree: "Full-Stack Software Engineering Fellowship",
  Location: "San Francisco, CA",
  Major: "Full-Stack Software Engineering",
  Date: "Feb. 2023",
  Icon: <UniIcon />,
};

educationData[1] = {
  id: "educationData1",
  School: "Fashion Institute of Technology",
  Degree: "Bachelor of Science Degree",
  Location: "New York City, NY",
  Major: "Merchandising Management —",
  Honors: "Magna Cum Laude",
  Date: "Dec. 2015",
  Icon: <UniIcon />,
};

educationData[2] = {
  id: "educationData1",
  School: "Polimoda",
  Degree: "Bachelor of Science Degree",
  Location: "Florence, Italy",
  Major: "Merchandising Management —",
  Honors: "Study Abroad",
  Date: "May 2015",
  Icon: <UniIcon />,
};

educationData[3] = {
  id: "educationData1",
  School: "Nassau Community College",
  Degree: "Associate In Applied Science Degree",
  Location: "Garden City, NY",
  Major: "Buying and Merchandising —",
  Honors: "Magna Cum Laude",
  Date: "May 2013",
  Icon: <UniIcon />,
};

export const certificateData = [];

certificateData[0] = {
  id: "certificationData1",
  School: "Udacity",
  Degree: "Nanodegree Degree",
  Location: "Mountain View, CA",
  Major: "Product Management",
  Date: "Apr. 2023",
  Icon: <BookmarkAddedOutlinedIcon />,
};

certificateData[1] = {
  id: "certificationData1",
  School: "Udacity",
  Degree: "Nanodegree Degree",
  Location: "Mountain View, CA",
  Major: "Front End Web Development",
  Date: "Jun. 2021",
  Icon: <BookmarkAddedOutlinedIcon />,
};
